import angular from 'angular';
import landingConfig from './landing.config';

import landing from '../../containers/landing';
import meredicte from '../../containers/meredicte';
import thesafezone from '../../containers/thesafezone';

const landingModule = angular.module('meredicte.landing', [])
  .component('appLanding', landing)
  .component('appMeredicte', meredicte)
  .component('appThesafezone', thesafezone)
  .config(landingConfig);

export default landingModule;



// WEBPACK FOOTER //
// ./src/modules/landing/landing.module.js